import { useState } from 'react';

const faqs = [
  {
    q: 'Que incluye exactamente la membresia Coverly?',
    a: 'La membresia permite registrar al titular y a familiares directos segun el plan contratado. Basico incluye titular + 2 familiares registrados. Prime incluye titular + 3 familiares registrados.',
  },
  {
    q: 'Cuando puedo solicitar los servicios?',
    a: 'Tu membresia se registra desde el primer pago. Los servicios pueden estar sujetos a periodo de carencia, condiciones del plan y disponibilidad de la red aliada.',
  },
  {
    q: 'Puedo elegir funeraria?',
    a: 'Cuando corresponde solicitar el servicio, Coverly coordina con funerarias aliadas de prestigio disponibles en la zona del cliente. La prioridad es que la familia reciba orientacion seria, clara y profesional.',
  },
  {
    q: 'Puedo cancelar?',
    a: 'Si. Coverly esta pensado como una membresia mensual clara, sin contratos forzosos ni procesos complicados.',
  },
  {
    q: 'Como pago mi membresia?',
    a: 'La app esta preparada para gestionar pagos, historial y referencias. Dejaremos integrados los metodos disponibles conforme avance la operacion.',
  },
  {
    q: 'Coverly Contigo cambia mi plan?',
    a: 'No. Coverly Contigo es un programa de beneficios adicionales para miembros activos. La oferta principal sigue siendo la membresia de prevision funeraria familiar.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-14 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex rounded-full border border-[#DDD8F5] bg-[#F7F6FF] px-4 py-2 text-xs font-black uppercase tracking-wide text-[#534AB7]">
            Resolvemos tus dudas
          </span>
          <h2 className="mt-5 font-title text-3xl font-black tracking-[-0.035em] text-[#171421] md:text-5xl">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((faq, index) => (
            <article key={faq.q} className="overflow-hidden rounded-3xl border border-[#E8E4F8] bg-[#FBFAFF]">
              <button
                onClick={() => setOpen(open === index ? null : index)}
                className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left"
              >
                <span className="text-base font-black text-[#242033]">{faq.q}</span>
                <span className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full transition-colors ${open === index ? 'bg-[#534AB7] text-white' : 'bg-white text-[#534AB7]'}`}>
                  <i className={`${open === index ? 'ri-subtract-line' : 'ri-add-line'} text-lg`} />
                </span>
              </button>
              {open === index && (
                <p className="px-5 pb-5 text-sm leading-7 text-[#6B6578]">
                  {faq.a}
                </p>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
